export var ApplePayEventsEnum;
(function (ApplePayEventsEnum) {
    ApplePayEventsEnum["Loaded"] = "applePayLoaded";
    ApplePayEventsEnum["FailedToLoad"] = "applePayFailedToLoad";
    ApplePayEventsEnum["Completed"] = "applePayCompleted";
    ApplePayEventsEnum["Canceled"] = "applePayCanceled";
    ApplePayEventsEnum["Failed"] = "applePayFailed";
})(ApplePayEventsEnum || (ApplePayEventsEnum = {}));
